import { React, useState, useEffect, useRef } from 'react'
import "../master.css"
import { toast } from 'react-toastify';
import ApiService from '../../../../services/apiService';
import userManagement from '../../../../services/userManagement';
import { ClipLoader } from "react-spinners";
import { useTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/creatable';
import { FaRegEdit } from "react-icons/fa";
const MarchaintMaster = () => {
    const [kitchen, setKitchen] = useState([]);
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const [terminal, setTerminal] = useState([]);
    const apiService = new ApiService();

    // useEffect(() => {
    //     GetMarchaint()
    //     GetTerminal()
    // }, []);

    const [formData, setFormData] = useState({
        id: "",
        name: "",
        terminal: []
    });
    const GetTerminal = async () => {
        try {
            let terRes = await apiService.get('GET_TERMINAL');
            let terFiltered = terRes.data.result.filter(res => res?.status == 1);
            setTerminal(terFiltered);
        } catch (error) {
            console.error('Error fetching Restaurant data:', error);
        }
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const CreateMarchaint = async () => {
        const UserId = userManagement.getUserId2();
        setLoading(true)
        if (!formData?.id) { toast.warning("Enter Merchant id") }
        else if (!formData?.name) { toast.warning("Enter Merchant name") }
        else if (!formData?.terminal) { toast.warning("Select Terminal") }
        try {
            let body = {
                merchantId: formData?.id,
                name: formData?.name,
                status: 1,
                createdBy: UserId,
                terminals: []
            };
            formData.terminal.forEach(ter => {
                body.terminals.push({
                    id: ter.value.id,
                    terminalId: ter?.value?.terminalId,
                });
            });
            debugger
            const apiService = new ApiService();
            let res = await apiService.post('CREATE_MARCHAINT', body);

            if (res?.data?.statusCode === 201) {
                toast.success("Merchant Created Successfully");
                setFormData({
                    id: "",
                    name: "",
                    terminal: []
                });
                GetMarchaint();
            } else {
                toast.error(res?.data?.message);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setLoading(false);
        }
    };
    const UpdateMarchaint = async () => {
        const UserId = userManagement.getUserId2();
        setLoading(true)
        if (!formData?.id) { toast.warning("Enter Merchant id") }
        else if (!formData?.name) { toast.warning("Enter Merchant name") }
        else if (!formData?.terminal) { toast.warning("Select Terminal") }
        try {
            let body = {
                id: formData?.mergId,
                merchantId: formData?.id,
                name: formData?.name,
                status: 1,
                createdBy: UserId,
                terminals: []
            };
            formData.terminal.forEach(ter => {
                body.terminals.push({
                    id: ter.value.id,
                    terminalId: ter?.value?.terminalId,
                });
            });
            const apiService = new ApiService();
            let res = await apiService.put('UPDATE_MARCHAINT', body);
            if (res?.data?.statusCode === 201) {
                toast.success("Merchant Updated Successfully");
                setFormData({
                    id: "",
                    name: "",
                    terminal: []
                });
                GetMarchaint();
            } else {
                toast.error(res?.data?.message);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setLoading(false);
        }
    };
    const GetMarchaint = async () => {
        try {
            const apiService = new ApiService();
            let res = await apiService.get('GET_MARCHAINT');
            setKitchen(res.data.result);
        } catch (error) {
            console.error('Error fetching QR data:', error);
        }
    };
    const handleSwitchChange = async (payment, newActiveStatus) => {
        try {
            await handleUpdatePayment(payment, newActiveStatus);
        } catch (error) {
            console.error('Error updating payment status:', error);
        }
    };
    const handleUpdatePayment = async (payment, newActiveStatus) => {
        try {
            const apiService = new ApiService();
            const catData = {
                id: payment?.id,
                active: newActiveStatus
            }

            const res = await apiService.put(`UPDATE_MARCHAINT`, catData);
            if (res?.data?.statusCode === 200) {
                toast.success(`${payment?.kitchenName} updated successfully!`);
                GetMarchaint();
            } else {
                toast.error("Failed to update Kitchen. Please try again!");
            }
        } catch (error) {
            console.error('Error updating Kitchen:', error);
        }
    };
    const handleModifierChange = (selectedOptions) => {
        // const processed = selectedOptions?.map(opt => ({
        //     value: opt.value,
        //     label: opt.label
        // })) || [];
        // setFormData({ ...formData, terminal: processed });
        setFormData({
            ...formData,
            terminal: selectedOptions || []
        });
    };
    const handleEdit = (data) => {
        const selectedTerminals = data?.merchantTerminals?.map(mt => {
            const matchingTerminal = terminal.find(t => t.terminalId === mt.terminalId);
            return {
                value: matchingTerminal || mt,
                label: mt.name
            };
        });

        setEdit(true);
        setFormData({
            ...formData,
            terminal: selectedTerminals,
            id: data?.merchantId,
            mergId: data?.id,
            name: data?.name,
        });
    };
    return (
        <div className='p-5 container' >
            <div className='catlist'>
                <div className='row d-flex'>
                    <div className='col-lg-4'>
                        <label htmlFor="validationCustom01" className="form-label">
                            {t('Merchant')} {t('Id')} *
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            name="id"
                            value={formData.id}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className='col-lg-4'>
                        <label htmlFor="validationCustom01" className="form-label">
                            {t('Merchant')} {t('name')}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="col-lg-4">
                        <label htmlFor="validationCustom15" className="form-label">
                            {t('select')} {t('terminal')}
                        </label>
                        <CreatableSelect
                            isMulti
                            options={terminal.map(ter => ({
                                value: ter,
                                label: ter.name
                            }))}
                            value={formData.terminal}
                            onChange={handleModifierChange}
                            placeholder={`${t('select')} ${t('terminal')}`}
                            isClearable
                        />
                    </div>
                </div>
                <div className="pt-5 end">
                    {loading ? (
                        <div className="addItem-btn center">
                            <ClipLoader loading={loading} size={30} color="#fff" />
                        </div>
                    ) : (
                        <>
                            {edit === true ?
                                <button className='addItem-btn' onClick={() => UpdateMarchaint()}>{t('update')}</button> :
                                <button className='addItem-btn' onClick={() => CreateMarchaint()}>{t('save')}</button>
                            }
                        </>
                    )}
                </div>
            </div>
            <div className='catlist mt-5 table-responsive'>
                <table className='table  mt-3'>
                    <thead>
                        <tr>
                            <th>{t('Merchant')} {t('ID')}</th>
                            <th>{t('Merchant')} {t('name')}</th>
                            <th>{t('action')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {kitchen?.map((val) => (
                            <tr key={val.id}>
                                <td>{val.merchantId}</td>
                                <td>{val.name}</td>
                                <td>
                                    <div className="d-flex gap-3">
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={val.status === 1}
                                                onChange={(e) => handleSwitchChange(val, e.target.checked)}
                                            />
                                        </div>
                                        <div className='center' onClick={() => handleEdit(val)}>
                                            <FaRegEdit size={25} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div >
    )
}

export default MarchaintMaster